import HtmlElement from '../../../Elements/HtmlElement';
import NavSubHorizontal from '../../../Elements/NavSubHorizontal';

/**
 * Disruptorbar
 */
const Disruptorbar = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		DISRUPTOR_BAR: '.disruptor-bar',
		MARQUEE: '.disruptor-bar-marquee',
		HIDE: '.disruptor-bar-hide',
		COUNTDOWN: '.disruptor-bar-countdown'
	};

	/**
	 * Disruptorbar
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class Disruptorbar extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this.$hide = this.$element.find(Selector.HIDE);
			this.$countdown = this.$element.find(Selector.COUNTDOWN);

			if (this.$hide.length) {
				this.$hide.on('click', () => {
					this.$element.fadeOut(300, () => {
						this.$element.remove();
					});
				});
			}

			if (this.$countdown.length) {
				const timestamp = parseInt(this.$countdown.data('timestamp'));
				this.$countdown.countdown(new Date(timestamp * 1000), (e) => {
					this.$countdown.html(
						e.strftime(`
							<div class="disruptor-bar-countdown-digit">
								<span>%D</span>
								Tage
							</div>
							<div class="disruptor-bar-countdown-digit">
								<span>%H</span>
								Stunden
							</div>
							<div class="disruptor-bar-countdown-digit">
								<span>%M</span>
								Minuten
							</div>
							<div class="disruptor-bar-countdown-digit">
								<span>%S</span>
								Sekunden
							</div>
						`)
					)
				});
			}

			this.$element.find(Selector.MARQUEE).marquee({
				duration: 10000,
				gap: 50,
				delayBeforeStart: 0,
				direction: 'left'
			});

			if (!$.trim($('.banner').html()).length && NavSubHorizontal.exists()) {
				const $firstSection = $('main > .frame > .main');
				const $firstBigImageText = $('main > .frame > .big-image-text');

				if ($firstSection.length || $firstBigImageText.length) {
					if ($firstSection.length) {
						const currentPaddingTop = parseFloat(window.getComputedStyle($firstSection.get(0)).getPropertyValue('padding-top'));
						$firstSection.css('padding-top', currentPaddingTop + this.$element.outerHeight());

						$(window).on('resize', () => {
							$firstSection.css('padding-top', '');
							const currentPaddingTop = parseFloat(window.getComputedStyle($firstSection.get(0)).getPropertyValue('padding-top'));
							$firstSection.css('padding-top', currentPaddingTop + this.$element.outerHeight());
						});
					}


					if ($firstBigImageText.length) {
						const currentPaddingTop = parseFloat(window.getComputedStyle($firstBigImageText.get(0)).getPropertyValue('padding-top'));
						$firstBigImageText.css('padding-top', currentPaddingTop + this.$element.outerHeight());

						$(window).on('resize', () => {
							$firstBigImageText.css('padding-top', '');
							const currentPaddingTop = parseFloat(window.getComputedStyle($firstBigImageText.get(0)).getPropertyValue('padding-top'));
							$firstBigImageText.css('padding-top', currentPaddingTop + this.$element.outerHeight());
						});
					}

					this.$hide.on('click', () => {
						setTimeout(() => {
							$firstSection.css('padding-top', '');
							$firstBigImageText.css('padding-top', '');
						}, 300);
					});
				}
			}
		}
	}

	return Disruptorbar._getElements(Selector.DISRUPTOR_BAR, Disruptorbar);
})();

export default Disruptorbar;
